import type { MODULATOR_TEST_RESULTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulator-test-results-card/modulator-test-results-card.fr.ts";

export const MODULATOR_TEST_RESULTS_CARD_ENGLISH_LOCALE = {
  title: "Installation tests",
} satisfies typeof MODULATOR_TEST_RESULTS_CARD_FRENCH_LOCALE;
